import { SVGIcon } from "@progress/kendo-svg-icons";

// Three overlapping person silhouettes (head + shoulders), for "Teams" - kendo-svg-icons has no
// multi-person icon, only a single `userIcon`.
export const teamsIcon: SVGIcon = {
  name: "teams-custom",
  content:
    '<path d="M40,420 Q40,300 120,300 Q200,300 200,420 Z" /><circle cx="120" cy="180" r="54" />' +
    '<path d="M312,420 Q312,300 392,300 Q472,300 472,420 Z" /><circle cx="392" cy="180" r="54" />' +
    '<path d="M146,440 Q146,300 256,300 Q366,300 366,440 Z" /><circle cx="256" cy="140" r="64" />',
  viewBox: "0 0 512 512",
};
